import React, { useEffect } from 'react'

import "./Placement.css";
import "./Placed_students.css";
import { Backtotop,Floatinmenu,Underline,Deptvision,Deptmission ,ContentCard} from "../../widgets";
import { placement_menu ,placed_students_db} from "../../constants/placement";

import {RadialMenu } from "../../components";

import { FaGraduationCap } from "react-icons/fa";

const Placed_students = () => {
    useEffect(() => {
        document.title='ACCET-Placement-Statistics';
      }, []);
  return (
    <div className='placement'>
    <div className='placementbg'>
      <div className='placementheading'>
        Placement
      </div>
      <div className='placement_sub_heading'>Placed Students Database</div>
    </div>
    <section className='placementdark'>
      <div className='dept_float_menu'>
      <Floatinmenu logo={FaGraduationCap} head="Menu" links={placement_menu} />
      </div>
      <RadialMenu menu_links={placement_menu}/>
      <Underline heading="Placed Students Database"/>
        <div className='placement_placed_students'>
            {placed_students_db.map((item)=>(
                <ContentCard key={item.id} heading={item.program} pdf={item.pdf} />
            ))}
        </div>
    </section>

    <Backtotop />
  </div>
  )
}

export default Placed_students;